import { render } from "./SignUpTab.vue?vue&type=template&id=7fa10ef8"
import script from "./SignUpTab.vue?vue&type=script&lang=js"
export * from "./SignUpTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__